import { createRouter, createWebHistory } from 'vue-router'

import { pages } from '@/config'
import { useMemberStore } from '@/stores/member.js'

const BonusCommissionPage = () => import(/* webpackChunkName: "p-bonus-commission" */ '@/pages/BonusCommission.vue')
const BannerPage = () => import(/* webpackChunkName: "p-banner" */ '@/pages/Banner.vue')
const CommissionPage = () => import(/* webpackChunkName: "p-commission" */ '@/pages/Commission.vue')
const ContractPage = () => import(/* webpackChunkName: "p-contract" */ '@/pages/Contract.vue')
const LandingPage = () => import(/* webpackChunkName: "p-landing" */ '@/pages/Landing.vue')
const PerformancePage = () => import(/* webpackChunkName: "p-performance" */ '@/pages/Performance.vue')
const RejectedPage = () => import(/* webpackChunkName: "p-rejected" */ '@/pages/Rejected.vue')
const Settings = () => import(/* webpackChunkName: "p-settings" */ '@/pages/Settings.vue')
const GenerateLink = () => import(/* webpackChunkName: "p-generate-link" */ '@/pages/GenerateLink.vue')
const CategoryBannerRenderPage = () => import(/* webpackChunkName: "p-category-banner-render" */ '@/pages/CategoryBannerRender.vue')
const ProductBannerRenderPage = () => import(/* webpackChunkName: "p-product-banner-render" */ '@/pages/ProductBannerRender.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: pages.unverified.path,
      name: pages.unverified.name,
      component: LandingPage
    },
    {
      path: pages.rejected.path,
      name: pages.rejected.name,
      component: RejectedPage,
      meta: {
        auth: true
      }
    },
    {
      path: pages.home.path,
      name: pages.home.name,
      component: LandingPage
    },
    {
      path: pages.register.path,
      name: pages.register.name,
      component: LandingPage
    },
    {
      path: pages.performance.path,
      name: pages.performance.name,
      component: PerformancePage,
      meta: {
        auth: true
      }
    },
    {
      path: pages.bonusCommission.path,
      name: pages.bonusCommission.name,
      component: BonusCommissionPage,
      meta: {
        auth: true
      }
    },
    {
      path: pages.commission.path,
      name: pages.commission.name,
      component: CommissionPage,
      meta: {
        auth: true
      }
    },
    {
      path: pages.generateLink.path,
      name: pages.generateLink.name,
      component: GenerateLink,
      meta: {
        auth: true
      }
    },
    {
      path: pages.banner.path,
      name: pages.banner.name,
      component: BannerPage,
      meta: {
        auth: true
      }
    },
    {
      path: pages.forgotPassword.path,
      name: pages.forgotPassword.name,
      component: LandingPage
    },
    {
      path: pages.resetPassword.path,
      name: pages.resetPassword.name,
      component: LandingPage,
      meta: {
        public: true
      }
    },
    {
      path: pages.changePassword.path,
      name: pages.changePassword.name,
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: pages.profile.path,
      name: pages.profile.name,
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: pages.bankInformation.path,
      name: pages.bankInformation.name,
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: pages.contract.path,
      name: pages.contract.name,
      component: ContractPage,
      meta: {
        auth: true
      }
    },
    {
      path: pages.categoryBannerRender.path,
      name: pages.categoryBannerRender.name,
      component: CategoryBannerRenderPage,
      meta: {
        public: true
      }
    },
    {
      path: pages.productBannerRender.path,
      name: pages.productBannerRender.name,
      component: ProductBannerRenderPage,
      meta: {
        public: true
      }
    }
  ]
})

const checkAuth = (to, from, next) => {
  const memberStore = useMemberStore()
  const { profile } = memberStore
  if (profile.init) {
    setRouting(true)
    setTimeout(() => checkAuth(to, from, next), 50)
    return
  }
  if (to.meta.public) {
    next()
  } else if (!profile?.data?.name) {
    if (to.meta.auth && !profile?.forbidden) {
      next(pages.home.path)
    } else {
      next()
    }
  } else {
    if (!to.meta.auth && !profile?.forbidden) {
      next(pages.performance.path)
    } else {
      next()
    }
  }
}

const setRouting = (v) => {
  const memberStore = useMemberStore()
  const { setAuthLoading } = memberStore
  setAuthLoading(v)
}

router.beforeEach((to, from, next) => {
  checkAuth(to, from, next)
})

router.afterEach(() => {
  setRouting(false)
})

export default router
